var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-alert',{class:[_vm.size === 'sm' ? 'font-lg' : '', _vm.variant === 'blue' ? 'alert-blue' : ''],attrs:{"show":"","variant":_vm.variant}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }